import { Component, Input } from '@angular/core';

import { ScreenStoreHour } from '../../../shared';

@Component({
  selector: 'signgaze-listing-hours',
  templateUrl: './listing-hours.component.html',
  styleUrls: ['./listing-hours.component.scss'],
})
export class ListingHoursComponent {
  @Input()
  screenHours: ScreenStoreHour[];
}
